'use strict';
define([
    'angular',
    'modules/seospider/exam/analysis/detail/browser/browser.controller'
],function(angular,SinglePageBrowserController){
    var app=angular.module('app.seospider.exam.analysis.detail.browser', []);
    app.controller('SinglePageBrowserController',SinglePageBrowserController);
    return app;
});